import { createStore, combineReducers } from 'redux';
import rootReducer from './root-reducer';
import interceptor from './interceptor';

const store = createStore(rootReducer);
interceptor(store);
export { store };
